import { DeviceI } from "./devices.model";
import { UserI } from "./users.model";

export type ChartType = 'puntosControl' | 'beacons' | 'pantallasSenderos' | 'registroUsuarios' | 'dispositivos';

export type ChartSubType = 
'puntosDeControlGuardados' | 'senderosCompletados' | // puntosControl
'notificacionesEnviadas' | 'beaconsGuardados' | // beacons
'visualizaciones' | 'descargasOffline' | // pantallasSenderos
'usuariosAnonimos' | 'usuariosRegistrados' | // registroUsuarios
'marcas' | 'modelos';  // dispositivos
export interface ChartConfig {
    type: string | undefined;
    xAxis: {
        type: string | undefined;
        dateTimeFormat: {
            day: string | undefined,
            month: string | undefined
        }
    }
}
export interface ChartData {
    id: string;
    date: Date;
    name: string;
    value: number;    
}

export interface ChartDataObjectI {
    users: Array<UserI>;
    devices: Array<DeviceI>;
}

export class ChartDataObject implements ChartDataObjectI {
    users: UserI[] = [];
    devices: DeviceI[] = [];

    constructor() {}

    addUsers(users: UserI[]): void {
        users.forEach(user => this.users.push(user));
    }

    addDevices(devices: DeviceI[]): void {
        devices.forEach(device => this.devices.push(device));
    }
    clickSerie(index: number) {
        console.log('serie clicked')
    }    
}
